export default __webpack_public_path__ + "static/media/product-microscope.c50b2abb.svg";